import React, { useEffect, useState, useRef, useCallback } from "react";
import Select from "react-select"; 
import AsyncSelect from "react-select/async"; 
import { customFetch } from '../apiClient';
import { useNavigate } from "react-router-dom";
import CreatableSelect from 'react-select/creatable';

import MedicineImportModal from './MedicineImportModal';


// ✅ COMPACTED DYNAMIC STYLES FOR REACT SELECT
const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '30px',
    height: '30px',
    fontSize: '11px',
    borderRadius: '4px',
    borderColor: state.isFocused ? 'var(--theme-color, #0088cc)' : '#cbd5e0',
    boxShadow: state.isFocused ? '0 0 0 1px var(--theme-color, #0088cc)' : 'none',
    '&:hover': { borderColor: 'var(--theme-color, #0088cc)' },
    borderWidth: '1px',
    backgroundColor: 'white'
  }),
  valueContainer: (base) => ({ ...base, padding: '0 8px' }),
  input: (base) => ({ ...base, margin: 0, padding: 0 }),
  indicatorsContainer: (base) => ({ ...base, height: '30px' }),
  menu: (base) => ({ ...base, zIndex: 9999, borderRadius: '4px', fontSize: '11px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }), 
  option: (base, state) => ({
    ...base,
    fontSize: '11px',
    padding: '6px 10px',
    backgroundColor: state.isSelected 
      ? 'var(--theme-color, #0088cc)' 
      : state.isFocused 
        ? 'color-mix(in srgb, var(--theme-color, #0088cc), white 90%)' 
        : 'white',
    color: state.isSelected ? 'white' : '#333',
    cursor: 'pointer',
    '&:active': { backgroundColor: 'var(--theme-color, #0088cc)', color: 'white' }
  }),
  placeholder: (base) => ({ ...base, color: '#a0aec0', fontSize: '11px' })
};

const unitOptions = [
  { value: "Leaf", label: "Leaf" },
  { value: "Piece", label: "Piece" },
];

const gstOptions = [
  { value: "0", label: "0%" },
  { value: "5", label: "5%" },
  { value: "9", label: "9%" },
  { value: "12", label: "12%" },
  { value: "18", label: "18%" },
  { value: "28", label: "28%" },
];

const MedicineForm = () => {
  const [form, setForm] = useState({
    medicine: "", brandid: null, categoryid: "", gstp: "",
    munit: "", iunit: "", medinunit: "", brandName: "",
    opqty: "", sdis: "", srate: "", mrp: "", hsncode: "",
  });

  const [categories, setCategories] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const [showBrandModal, setShowBrandModal] = useState(false);
  const [brandForm, setBrandForm] = useState({ name: "" });
  const [brandSaving, setBrandSaving] = useState(false);
  const [brandError, setBrandError] = useState("");
  const [brandOptions, setBrandOptions] = useState([]);
  const [showImportModal, setShowImportModal] = useState(false);

  const navigate = useNavigate();
  const formRef = useRef(null);

  useEffect(() => {
    if (success) { const timer = setTimeout(() => setSuccess(""), 3000); return () => clearTimeout(timer); }
  }, [success]);

  useEffect(() => {
    if (error) { const timer = setTimeout(() => setError(""), 4000); return () => clearTimeout(timer); }
  }, [error]);

//  useEffect(() => {
//     const loadCategories = async () => {
//         try {
//             const res = await customFetch(`/MedCategoryDT`);
//             if (res.ok) {
//                 const data = await res.json();
//                 setCategories(data);
//                 setCategoryOptions(data.map(c => ({ value: c.cid, label: c.name })));
//             }
//         } catch (err) { console.error(err); }
//     };

//     // 👇 NAYA FUNCTION: Saare brands fetch karne ke liye
//     const loadAllBrands = async () => {
//         try {
//             // Bina search parameter ke call karein taaki saare brands aa jayein
//             const res = await customFetch(`/MedBrandDT`);
//             if (res.ok) {
//                 const data = await res.json();
//                 // Map karke options format mein set karein
//                 setBrandOptions(data.map(b => ({ value: b.bid, label: b.bName })));
//             }
//         } catch (err) { console.error(err); }
//     };

//     loadCategories();
//     loadAllBrands(); // 👈 Isko call kar dein

//     if (formRef.current) {
//         const firstInput = formRef.current.querySelector('input:not([disabled]):not([type="hidden"])');
//         firstInput?.focus();
//     }
// }, []);


// 👇 1. Functions ko useEffect ke bahar define kiya
  const loadCategories = async () => {
    try {
      const res = await customFetch(`/MedCategoryDT`);
      if (res.ok) {
        const data = await res.json();
        setCategories(data); // (Optional: Agar aage use nahi karna toh isko hata sakte ho)
        setCategoryOptions(data.map(c => ({ value: c.cid, label: c.name })));
      }
    } catch (err) { console.error(err); }
  };

  const loadAllBrands = async () => {
    try {
      const res = await customFetch(`/MedBrandDT`);
      if (res.ok) {
        const data = await res.json();
        setBrandOptions(data.map(b => ({ value: b.bid, label: b.bName })));
      }
    } catch (err) { console.error(err); }
  };

  // 👇 2. useEffect me ab sirf inko call karenge
  useEffect(() => {
    loadCategories();
    loadAllBrands();

    if (formRef.current) {
      const firstInput = formRef.current.querySelector('input:not([disabled]):not([type="hidden"])');
      firstInput?.focus();
    }
  }, []);

 

  const handleSelectChange = (name, selectedOption) => {
    setForm(prev => ({
        ...prev,
        [name]: selectedOption ? selectedOption.value : (name === 'brandid' ? null : "")
    }));
    
    if (name === 'brandid' && selectedOption) {
        setForm(prev => ({ ...prev, brandName: selectedOption.label }));
    }
  };

  const calculateFields = (name, value) => {
    const currentMrp = parseFloat(form.mrp || value || 0);
    const currentSdis = parseFloat(form.sdis || 0);
    
    if (name === "mrp") {
      if (currentSdis > 0) {
        const discountAmount = (parseFloat(value) * currentSdis) / 100;
        setForm(prev => ({ ...prev, mrp: value, srate: (parseFloat(value) - discountAmount).toFixed(2) }));
      } else {
        setForm(prev => ({ ...prev, mrp: value }));
      }
    } else if (name === "sdis") {
      if (currentMrp > 0) {
        const discountAmount = (currentMrp * parseFloat(value)) / 100;
        setForm(prev => ({ ...prev, sdis: value, srate: (currentMrp - discountAmount).toFixed(2) }));
      } else {
        setForm(prev => ({ ...prev, sdis: value }));
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (['mrp', 'sdis'].includes(name)) calculateFields(name, value);
    else setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleKeyDown = useCallback((e) => {
    const focusableElements = formRef.current?.querySelectorAll(
      'input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea, button:not([disabled])'
    );

    if (!focusableElements || focusableElements.length === 0) return;
    
    const elementsArray = Array.from(focusableElements);
    const currentIndex = elementsArray.indexOf(e.target);

    if (e.key === "Enter" || e.key === "ArrowRight") {
      e.preventDefault(); 
      if (e.key === "Enter" && currentIndex === elementsArray.length - 1) {
        e.target.closest("form").requestSubmit();
        return;
      }
      const nextIndex = Math.min(elementsArray.length - 1, currentIndex + 1);
      elementsArray[nextIndex]?.focus();
    }
    else if (e.key === "ArrowLeft") {
      e.preventDefault(); 
      const prevIndex = Math.max(0, currentIndex - 1);
      elementsArray[prevIndex]?.focus();
    }
  }, []);

  useEffect(() => {
    const handler = (e) => { if (formRef.current && e.target.closest("form") === formRef.current) handleKeyDown(e); };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [handleKeyDown]);
  
  const handleSubmit = async (e) => {
    e.preventDefault(); setError(""); setSuccess("");

    if (!form.medicine?.trim()) { setError("Medicine Name is required."); return; }
    if (!form.brandid) { setError("Please select a Brand."); return; }
    if (!form.categoryid) { setError("Please select a Category."); return; }

    setLoading(true);
    try {
      const token = sessionStorage.getItem("token");

      const opQty = parseFloat(form.opqty) || 0; 
      const packSize = parseFloat(form.iunit) || 1; 
      const unit = form.munit || ""; 

      let totalPieces = 0;
      if (["Leaf", "Box", "Strip"].includes(unit)) {
          totalPieces = opQty * packSize; 
      } 
      else {
          totalPieces = opQty; 
      }

      const fd = new FormData();
      fd.append("Medicine", form.medicine.trim());
      fd.append("Brandid", form.brandid);
      fd.append("Categoryid", form.categoryid);
      fd.append("OPQTY", totalPieces); 

      if (form.gstp) fd.append("GSTP", form.gstp);
      if (form.munit) fd.append("MUnit", form.munit.trim());
      if (form.iunit) fd.append("IUnit", form.iunit);
      if (form.medinunit) fd.append("MediInUnit", form.medinunit.trim());
      
     fd.append("SDis", form.sdis || 0);
fd.append("SRate", form.srate || 0);
fd.append("MRP", form.mrp || 0);
      if (form.hsncode) fd.append("HSNCODE", form.hsncode);

     const res = await customFetch(`/MedicineDT`, {
        method: "POST", body: fd
      });

     if (!res.ok) throw new Error(await res.text());
      setSuccess("Medicine saved successfully.");
      setForm({
        medicine: "", brandid: null, categoryid: "", gstp: "", munit: "", iunit: "",
        medinunit: "", brandName: "", opqty: "", sdis: "", srate: "", mrp: "", hsncode: "",
      });
      formRef.current?.querySelector('input')?.focus();
    } catch (err) { setError(err.message); } finally { setLoading(false); }
  };

  return (
    <div className="medicine-container">
      <div className="medicine-card">
        <div className="medicine-header">
          <div className="header-left">
             <div className="header-icon"><i className="bi bi-capsule"></i></div>
             <div className="header-text"><h5>Add Medicine</h5><p>Create new medicine entry</p></div>
          </div>
        <div className="header-actions" style={{ display: 'flex', gap: '8px' }}>
             {/* Naya Import Button */}
             <button type="button" onClick={() => setShowImportModal(true)} className="btn-header-action" style={{ background: '#38a169', borderColor: '#2f855a' }} title="Import via CSV">
                 <i className="bi bi-file-earmark-spreadsheet"></i> <span>Import CSV</span>
             </button>

             {/* Purana View List Button */}
             {/* <button type="button" onClick={() => navigate('/master/medicine-list')} className="btn-header-action" title="View List" tabIndex="-1">
                 <i className="bi bi-list-ul"></i> <span>View List</span>
             </button> */}
          </div>
        </div>

        <div className="card-content">
          {error && <div className="alert-custom alert-danger"><i className="bi bi-exclamation-circle-fill"></i> {error}</div>}
          {success && <div className="alert-custom alert-success"><i className="bi bi-check-circle-fill"></i> {success}</div>}

          <form ref={formRef} onSubmit={handleSubmit}>
            
            {/* ROW 1 */}
            <div className="form-row three-col">
               <div className="form-group">
                 <label className="form-label">Medicine Name <span className="req">*</span></label>
                 <input name="medicine" value={form.medicine} onChange={handleChange} className="form-input" placeholder="e.g. Paracetamol" required />
               </div>

               {/* BRAND */}
               <div className="form-group">
                 <label className="form-label">Brand <span className="req">*</span></label>
                 <div className="combo-input">
                    <div className="flex-1">
                       <Select
   options={brandOptions}
   value={brandOptions.find(b => b.value === form.brandid) || null}
   onChange={(opt) => handleSelectChange('brandid', opt)}
   placeholder="Select or Search Brand..." 
   isClearable 
   isSearchable={true} /* 👈 Yeh line default true hoti hai, is se search enable ho jata hai */
   styles={selectStyles} 
   menuPortalTarget={document.body} 
   menuPosition="fixed"
/>
                    </div>
                    <button type="button" className="btn-icon-add" onClick={() => { setBrandForm({ name: "" }); setBrandError(""); setShowBrandModal(true); }} title="Add New Brand" tabIndex="-1">
                        <i className="bi bi-plus-lg"></i>
                    </button>
                 </div>
               </div>

               {/* CATEGORY */}
               <div className="form-group">
                 <label className="form-label">Category <span className="req">*</span></label>
                 <Select
                    options={categoryOptions}
                    value={categoryOptions.find(c => c.value === form.categoryid) || null}
                    onChange={(opt) => handleSelectChange('categoryid', opt)}
                    placeholder="Select..." isClearable
                    styles={selectStyles} menuPortalTarget={document.body} menuPosition="fixed"
                 />
               </div>
            </div>

            {/* ROW 2 */}
            <div className="form-row five-col">
               <div className="form-group flex-2">
                 <label className="form-label">Composition</label>
                 <input name="medinunit" value={form.medinunit} onChange={handleChange} className="form-input" placeholder="e.g. 500mg" />
               </div>
               
               <div className="form-group">
                 <label className="form-label">Unit</label>
                 <Select
                    options={unitOptions}
                    value={unitOptions.find(u => u.value === form.munit) || null}
                    onChange={(opt) => handleSelectChange('munit', opt)}
                    placeholder="Select" styles={selectStyles} menuPortalTarget={document.body} menuPosition="fixed"
                 />
               </div>

               <div className="form-group">
                 <label className="form-label">Pack Size</label>
                 <input type="number" step="0.01" name="iunit" value={form.iunit} onChange={handleChange} className="form-input" placeholder="10" />
               </div>

               <div className="form-group">
                 <label className="form-label">GST %</label>
                 <CreatableSelect
                   isClearable
                   options={gstOptions}
                   // 🟢 LOGIC: Agar pre-defined option nahi mila, toh typed value ka custom object bana do
                   value={
                     form.gstp 
                       ? (gstOptions.find(g => g.value === String(form.gstp)) || { value: String(form.gstp), label: `${form.gstp}%` }) 
                       : null
                   }
                   onChange={(opt) => handleSelectChange('gstp', opt)}
                   placeholder="Select or type" 
                   formatCreateLabel={(inputValue) => `Add custom "${inputValue}%"`} // 👈 Naya type karte waqt ye hint aayega
                   styles={selectStyles} 
                   menuPortalTarget={document.body} 
                   menuPosition="fixed"
                 />
               </div>
            </div>

            {/* ROW 3 */}
            <div className="form-row five-col">
               {/* <div className="form-group">
                 <label className="form-label">Opening Stock</label>
                 <input type="number" step="0.01" name="opqty" value={form.opqty} onChange={handleChange} className="form-input" placeholder="0" />
               </div>
               <div className="form-group">
                 <label className="form-label">MRP</label>
                 <input type="number" step="0.01" name="mrp" value={form.mrp} onChange={handleChange} className="form-input" placeholder="0.00" />
               </div>
               <div className="form-group">
                 <label className="form-label">Sale Disc %</label>
                 <input type="number" step="0.01" max="100" name="sdis" value={form.sdis} onChange={handleChange} className="form-input" placeholder="0" />
               </div>
               <div className="form-group">
                 <label className="form-label">Sale Rate <span className="text-muted">(Auto)</span></label>
                 <input type="number" step="0.01" name="srate" value={form.srate} className="form-input readonly" readOnly placeholder="0.00" tabIndex="-1" />
               </div> */}
               <div className="form-group">
                 <label className="form-label">HSN Code</label>
                 <input type="text" name="hsncode" value={form.hsncode} onChange={handleChange} className="form-input" placeholder="Code" maxLength={15} />
               </div>
            </div>

            <div className="form-footer">
               <button type="submit" className="btn-submit" disabled={loading}>
                 {loading ? <span className="spinner-border spinner-border-sm"></span> : <i className="bi bi-check-lg"></i>} 
                 {loading ? " Saving..." : " Save Medicine"}
               </button>
            </div>
          </form>
        </div>
      </div>

      {/* Brand Modal */}
      {showBrandModal && (
        <>
          <div className="modal-overlay" onClick={() => setShowBrandModal(false)}></div>
          <div className="modal-container">
            <div className="modal-card">
              <div className="modal-header">
                <div className="modal-title">Add New Brand</div>
                <button className="btn-modal-close" onClick={() => setShowBrandModal(false)}><i className="bi bi-x-lg"></i></button>
              </div>
              <div className="modal-body">
                {brandError && <div className="alert-custom alert-danger mb-2"><i className="bi bi-exclamation-circle-fill"></i> {brandError}</div>}
                <div className="form-group">
                   <label className="form-label">Brand Name <span className="req">*</span></label>
                   <input className="form-input" value={brandForm.name} onChange={(e) => setBrandForm({ name: e.target.value })} placeholder="Enter brand name" autoFocus />
                </div>
              </div>
              <div className="modal-footer">
                 <button className="btn-modal-cancel" onClick={() => setShowBrandModal(false)}>Cancel</button>
               <button className="btn-modal-submit" disabled={brandSaving} onClick={async () => {
                    if (!brandForm.name.trim()) { setBrandError("Name required."); return; }
                    setBrandSaving(true); setBrandError("");
                    try {
                      const fd = new FormData(); fd.append("BName", brandForm.name.trim());
                      const res = await customFetch(`/MedBrandDT`, { method: "POST", body: fd });
                      if (!res.ok) throw new Error(await res.text());
                      const newBrand = await res.json();
                      setForm(prev => ({ ...prev, brandid: newBrand.bid, brandName: newBrand.bName }));
                      setShowBrandModal(false);
                    } catch (e) { setBrandError(e.message); } finally { setBrandSaving(false); }
                 }}>
                   {brandSaving ? "Saving..." : "Save Brand"}
                 </button>
              </div>
            </div>
          </div>
        </>
      )}

<MedicineImportModal 
          isOpen={showImportModal} 
          onClose={() => setShowImportModal(false)} 
          onSuccess={() => {
              // Jab import successful ho jaye, toh Brands aur Categories wapas fetch karo
              // taaki dropdown me naye added data turant dikhne lag jayein.
              loadCategories(); 
              loadAllBrands();
              setSuccess("Medicines imported successfully!");
          }} 
      />


      {/* COMPACT STYLES */}
      <style jsx>{`
        .medicine-container { padding: 0; font-family: system-ui, -apple-system, sans-serif; }
        .medicine-card { background: white; border-radius: 6px; box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1); border: 1px solid #e2e8f0; overflow: visible; }

        /* Header */
        .medicine-header { background: var(--theme-color, #0088cc); padding: 8px 12px; border-bottom: 2px solid #00d4aa; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 8px; }
        .header-left { display: flex; align-items: center; gap: 8px; color: white; }
        .header-icon { width: 28px; height: 28px; background: rgba(255, 255, 255, 0.2); border-radius: 4px; display: flex; align-items: center; justify-content: center; font-size: 14px; }
        .header-text h5 { margin: 0; font-size: 14px; font-weight: 600; }
        .header-text p { margin: 0; color: rgba(255, 255, 255, 0.85); font-size: 10px; }

        .btn-header-action { padding: 4px 10px; border-radius: 4px; border: 1px solid rgba(255, 255, 255, 0.3); background: rgba(255, 255, 255, 0.15); color: white; font-size: 11px; font-weight: 600; cursor: pointer; transition: 0.2s; display: flex; align-items: center; gap: 5px; }
        .btn-header-action:hover { background: white; color: var(--theme-color, #0088cc); }

        .card-content { padding: 12px; }

        /* Alerts */
        .alert-custom { margin-bottom: 12px; padding: 6px 10px; border-radius: 4px; display: flex; align-items: center; gap: 6px; font-size: 11px; font-weight: 500; }
        .alert-danger { background: #fff5f5; color: #e53e3e; border: 1px solid #feb2b2; }
        .alert-success { background: #f0fff4; color: #27ae60; border: 1px solid #9ae6b4; }

        /* Form Grid */
        .form-row { display: grid; gap: 10px; margin-bottom: 12px; }
        .three-col { grid-template-columns: 2fr 1.5fr 1.5fr; }
        .five-col { grid-template-columns: repeat(5, 1fr); }
        .flex-2 { grid-column: span 2; }

        .form-group { display: flex; flex-direction: column; gap: 4px; }
        .form-label { font-size: 11px; font-weight: 600; color: #4a5568; }
        .req { color: #e53e3e; }
        .text-muted { color: #a0aec0; font-weight: 400; font-size: 10px; }

        .form-input { padding: 6px 8px; border: 1px solid #cbd5e0; border-radius: 4px; font-size: 11px; color: #2d3748; width: 100%; outline: none; transition: 0.2s; background: white; height: 30px; }
        .form-input:focus { border-color: var(--theme-color, #3182ce); box-shadow: 0 0 0 1px var(--theme-color, #3182ce); }
        .readonly { background: #f7fafc; cursor: not-allowed; color: #718096; border-color: #e2e8f0; }

        .combo-input { display: flex; gap: 4px; }
        .flex-1 { flex: 1; }
        .btn-icon-add { width: 30px; height: 30px; border: 1px solid var(--theme-color, #3182ce); background: #ebf8ff; border-radius: 4px; cursor: pointer; color: var(--theme-color, #3182ce); display: flex; align-items: center; justify-content: center; transition: 0.2s; font-size: 14px; flex-shrink: 0; }
        .btn-icon-add:hover { background: var(--theme-color, #3182ce); color: white; }

        .form-footer { margin-top: 12px; padding-top: 10px; border-top: 1px solid #e2e8f0; text-align: right; }
        .btn-submit { padding: 0 16px; border-radius: 4px; border: none; background: #38a169; color: white; font-size: 11px; font-weight: 600; cursor: pointer; transition: 0.2s; height: 30px; display: inline-flex; align-items: center; gap: 6px; }
        .btn-submit:hover:not(:disabled) { background: #2f855a; }
        .btn-submit:disabled { opacity: 0.6; cursor: not-allowed; }

        /* Modal Compact */
        .modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.5); z-index: 1040; animation: fadeIn 0.2s ease; }
        .modal-container { position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 1050; width: 90%; max-width: 320px; animation: slideUp 0.2s ease; }
        .modal-card { background: white; border-radius: 6px; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15); overflow: hidden; }
        .modal-header { background: var(--theme-color, #3182ce); padding: 8px 12px; display: flex; justify-content: space-between; align-items: center; color: white; font-weight: 600; font-size: 12px; }
        .btn-modal-close { background: transparent; border: none; color: white; font-size: 14px; cursor: pointer; display: flex; align-items: center; justify-content: center; }
        .modal-body { padding: 12px; }
        .modal-footer { padding: 8px 12px; background: #f8fafc; border-top: 1px solid #e2e8f0; display: flex; justify-content: flex-end; gap: 6px; }
        .btn-modal-cancel { padding: 6px 12px; border-radius: 4px; border: none; background: #edf2f7; color: #4a5568; font-size: 11px; font-weight: 600; cursor: pointer; }
        .btn-modal-cancel:hover { background: #e2e8f0; }
        .btn-modal-submit { padding: 6px 12px; border-radius: 4px; border: none; background: var(--theme-color, #3182ce); color: white; font-size: 11px; font-weight: 600; cursor: pointer; }
        .btn-modal-submit:hover:not(:disabled) { opacity: 0.9; }

        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { opacity: 0; transform: translate(-50%, -40%); } to { opacity: 1; transform: translate(-50%, -50%); } }

        /* Responsive Breakpoints */
        @media (max-width: 992px) {
          .three-col { grid-template-columns: 1fr 1fr; }
          .five-col { grid-template-columns: repeat(3, 1fr); }
        }
        @media (max-width: 576px) {
          .medicine-header { flex-direction: column; align-items: stretch; text-align: center; }
          .header-left { justify-content: center; }
          .three-col, .five-col { grid-template-columns: 1fr; }
          .flex-2 { grid-column: span 1; }
          .btn-submit { width: 100%; justify-content: center; }
          .btn-header-action { justify-content: center; }
        }

        
      `}</style>
    </div>
  );
};




export default MedicineForm;